export default __webpack_public_path__ + "static/media/rarity-super-rare.383d07f3.svg";